import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import Links from '../constants/Links';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
// @ts-expect-error untyped
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DealStageEmptyState = () => /*#__PURE__*/_jsx(EmptyState, {
  "data-test-id": "deal-stage-empty-state-message",
  titleText: /*#__PURE__*/_jsx(Text, {
    as: "h4",
    marginBlockEnd: "400",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "repOverviewTable.emptyState.header"
    })
  }),
  primaryContent: /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "repOverviewTable.emptyState.body_jsx",
      options: {
        href: Links.PAID_SALES_SEATS
      },
      elements: {
        Link
      }
    }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "repOverviewTable.emptyState.body2_jsx",
      options: {
        href: Links.USER_SETTINGS
      },
      elements: {
        Link
      }
    }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "repOverviewTable.emptyState.body3"
    }), /*#__PURE__*/_jsx(KnowledgeBaseButton, {
      url: Links.SET_UP_FORECAST_TOOL_KB,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "repOverviewTable.emptyState.body4"
      })
    })]
  }),
  secondaryContent: /*#__PURE__*/_jsx(Illustration, {
    name: "forecasting",
    width: "100%"
  }),
  secondaryContentWidth: 150
});